<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <grant-wizard v-if="GrantForm.initialized" :is-editable="GrantForm.isEditable || (GrantForm.isRevisionEditable && GrantForm.isOnARevisionTab)">
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{ $t('medium_grant.technical_title') }}</p>
            </template>
            <step-technical-application></step-technical-application>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-money-coins"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('medium_grant.budget_title')}}</p>
            </template>
            <step-budget></step-budget>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('medium_grant.logical_title')}}</p>
            </template>
            <step-logical-framework></step-logical-framework>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-chart-bar-32"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('medium_grant.diligence_title')}}</p>
            </template>
            <step-due-diligence-form></step-due-diligence-form>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-send"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('medium_grant.submit_title')}}</p>
            </template>
            <step-submit-proposal></step-submit-proposal>
          </grant-wizard-tab>
        </grant-wizard>
      </div>
    </div>
  </div>
</template>
<script>
  import StepTechnicalApplication from './Steps/TechnicalApplication'
  import StepBudget from './Steps/Budget'
  import StepLogicalFramework from './Steps/LogicalFramework'
  import StepDueDiligenceForm from './Steps/DueDiligenceForm'
  import StepSubmitProposal from './Steps/SubmitProposal'

  import {EventBus} from '@/event-bus.js';
  import swal from 'sweetalert2';
  import {GrantWizard, GrantWizardTab} from 'src/components';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      GrantWizard,
      GrantWizardTab,
      StepTechnicalApplication,
      StepBudget,
      StepLogicalFramework,
      StepDueDiligenceForm,
      StepSubmitProposal
    },
    created() {
      EventBus.$off('set-active-tab');

      EventBus.$on('wizard-save-progress', data => {
        this.onBeforeSaveProgress(data);
      });

      EventBus.$on('wizard-complete-progress', data => {
        this.onBeforeCompleteProgress(data);
      });
    },
    methods: {
      async onBeforeSaveProgress(data) {
        let valid = await this.validate();
        if (valid) {
          EventBus.$emit('grant-save-progress', data);
        }
      },

      async onBeforeCompleteProgress(data) {
        let valid = await this.validate();
        if (!valid) {
          return;
        }

        var submitConfirmation = await this.showPreSubmitNotification().then((result) => {
          return result.value ? true : false;
        });

        if (submitConfirmation) {
          EventBus.$emit('grant-complete-progress', data);
        }
      },

      async validate() {
        let valid = true;
        let vm = this;
        let mandatoryFields = [
          {
            translation: vm.$t('medium_grant.technical__1_region'),
            value: GrantForm.regionId
          }
        ];

        let errorFields = [];
        mandatoryFields.forEach(item => {
          if (item.value === undefined || !item.value || (Array.isArray(item.value) && !item.value.length)) {
            errorFields.push(item.translation);
          }
        })

        if (errorFields.length) {
          valid = false;
          await this.showNotificationMandatoryFields(errorFields);

          EventBus.$emit('set-active-tab', {
            masterNickname: 'technical',
            masterIndex: 0,
            childIndex: 0,
            validate: true
          });
        }
        return valid;
      },

      showNotificationMandatoryFields(fields) {
        for (var i = 0; i < fields.length; i++) {
          fields[i] = "* " + fields[i];
        }
        let fieldsHtml = '<div class="text-danger">' + fields.join("<br>") + '</div>';
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__mandatory_fields', [fieldsHtml]).split("\n").join("<br>"),
          type: 'warning',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: 'OK'
        })
      },

      showPreSubmitNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__pre_submit_application').split("\n").join("<br>"),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: this.$t('general.notification__submit_application'),
          cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
          cancelButtonText: this.$t('general.notification__cancel_submit_application'),
        })
      }
    }
  };
</script>
